import { Flex } from "antd";
import { RightOutlined } from "@ant-design/icons";

export const TaskArtifacts = ({ artifacts }) => {
  if (!artifacts) {
    return null;
  }
  const content = (
    <div
      style={{
        padding: "1rem",
      }}
    >
      {Object.entries(JSON.parse(artifacts)).map(([name, url]) => (
        <div key={name}>
          <div>
            <a href={url} target="_blank" rel="noopener noreferrer">
              <Flex gap={4}>
                <RightOutlined style={{ color: "grey", width: "10px" }} />
                {name}
              </Flex>
            </a>
          </div>
        </div>
      ))}
    </div>
  );

  return content;
};
